<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Reagendar Acompanhamento' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <form class="sample-form validations-form" [formGroup]="validations_form">
    <div class="gradient-extendido"></div>

    <ion-card-content>
      <ng-container>
        <prover-datepicker
          [labelName]="'Nova Data de Início'"
          [id]="'dataHora_data'"
          [(dateTime)]="dataIni"
          formControlName="dataHora_data"
          [required]="true"
          [disabled]="validations_form.get('dataHora_data')?.disabled ?? false"
        ></prover-datepicker>

        <div class="validation-errors ion-margin-start">
          <ng-container *ngFor="let validation of validation_messages.dataHora_data">
            <div
              class="error-message"
              *ngIf="validations_form.get('dataHora_data')?.hasError(validation.type) && (validations_form.get('dataHora_data')?.dirty || validations_form.get('dataHora_data')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container>
        <app-prover-horas
          [labelName]="'Nova Hora Início'"
          [id]="'dataHora_hora'"
          formControlName="dataHora_hora"
          [required]="true"
          [isLabel]="true"
        ></app-prover-horas>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.dataHora_hora">
            <div
              class="error-message"
              *ngIf="validations_form.get('dataHora_hora')?.hasError(validation.type) && (validations_form.get('dataHora_hora')?.dirty || validations_form.get('dataHora_hora')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container>
        <prover-datepicker
          [labelName]="'Nova Data de Fim'"
          [id]="'dataHoraFim_data'"
          [(dateTime)]="dataFim"
          formControlName="dataHoraFim_data"
          [required]="true"
          [disabled]="validations_form.get('dataHoraFim_data')?.disabled ?? false"
        ></prover-datepicker>

        <div class="validation-errors ion-margin-start">
          <ng-container *ngFor="let validation of validation_messages.dataHoraFim_data">
            <div
              class="error-message"
              *ngIf="validations_form.get('dataHoraFim_data')?.hasError(validation.type) && (validations_form.get('dataHoraFim_data')?.dirty || validations_form.get('dataHoraFim_data')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container>
        <app-prover-horas
          [labelName]="'Nova Hora Fim'"
          [id]="'dataHoraFim_hora'"
          formControlName="dataHoraFim_hora"
          [required]="true"
          [isLabel]="true"
        ></app-prover-horas>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.dataHoraFim_hora">
            <div
              class="error-message"
              *ngIf="validations_form.get('dataHoraFim_hora')?.hasError(validation.type) && (validations_form.get('dataHoraFim_hora')?.dirty || validations_form.get('dataHoraFim_hora')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ion-row>
        <ion-col size="12" class="ion-padding-horizontal">
          <ion-select
            labelPlacement="stacked"
            interface="action-sheet"
            placeholder="{{'Motivo' | translate}}"
            cancelText="{{ 'Cancelar' | translate}}"
            okText="{{ 'Confirmar' | translate}}"
            formControlName="idAcompanhamentoStatus"
          >
            <div slot="label" class="slot-label">{{'Motivo' | translate}} <ion-text color="danger">*</ion-text></div>
            <ion-select-option *ngFor="let status of statusList" [value]="status.id">{{status.nome}}</ion-select-option>
          </ion-select>

          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.idAcompanhamentoStatus">
              <div
                class="error-message"
                *ngIf="validations_form.get('idAcompanhamentoStatus')?.hasError(validation.type) && (validations_form.get('idAcompanhamentoStatus')?.dirty || validations_form.get('idAcompanhamentoStatus')?.touched)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>
    </ion-card-content>

    <ion-row class="ion-justify-content-center">
      <ion-col size="11">
        <ion-button expand="block" class="btn-default" (click)="reagendar()" style="font-size: 12px">
          {{'Reagendar' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </form>
</ion-content>
